// Export payload for the menu-test block: everything the pptx getMenuTestParams /
// summary / download exporters read off the block beyond the model attrs — the menu view the
// heatmap composite is drawn by, the sections/products metrics the slide is titled with, the
// shared sort order, and which blocks the reader has closed, since a closed block exports nothing.
export const calcExportData = ({
  menuViewMode,
  sectionsViewMode,
  productViewMode,
  sortOrder,
  menuCollapsed,
  sectionsCollapsed,
  productsCollapsed
} = {}) => ({
  menuViewMode,
  sectionsViewMode,
  productViewMode,
  sortOrder,
  menuCollapsed,
  sectionsCollapsed,
  productsCollapsed
})
